import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../layout";
import ViewCustomerComponent from "../../components/customer-components/customer-view-component";
import CustomerActivityList from "../../components/customer-components/customer-activity/customer-activity-list";
import CustomerDeliveryListList from "../../components/customer-components/customer-delivery-address/customer-delivery-address-list";
import CustomerCommentsList from "../../components/customer-components/customer-comments/customer-comments-list";
import CustomerFileCommentsLits from "../../components/customer-components/customer-comments/customer-file-comments-lits";
import { useRole } from "../../context/role/RoleContext";
import CustomerPaymentList from "../../components/customer-components/customer-payment/customer-payment-list";
import CustomerOrdersList from "../../components/customer-components/customer-orders/customer-orders-list";

const ViewCustomer = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { state } = useRole();
  const permission = state?.role?.customer_activity;
  const queryParams = new URLSearchParams(location.search);
  const activeTab = queryParams.get("activeTab");

  return (
    <MainLayout>
      <section className="flex flex-col">
        <div className="my-4 bg-lightBg px-3 py-1 flex justify-between items-center">
          <div className="flex overflow-auto gap-4 items-center text-nowrap">
            <button
              className={` px-5 py-1 rounded-lg text-white
          ${activeTab === "customer" ? "bg-primary " : "bg-lightText"}
          `}
              onClick={() =>
                navigate(`/customer/view/${id}?activeTab=customer`)
              }
            >
              customer
            </button>
            {(permission?.read || permission?.write) && (
              <button
                className={` px-5 py-1 rounded-lg text-white
          ${activeTab === "activity" ? "bg-primary" : "bg-lightText"}
          `}
                onClick={() =>
                  navigate(`/customer/view/${id}?activeTab=activity`)
                }
              >
                Activity
              </button>
            )}
            <button
              className={` px-5 py-1 rounded-lg text-white
          ${activeTab === "address" ? "bg-primary" : "bg-lightText"}
          `}
              onClick={() => navigate(`/customer/view/${id}?activeTab=address`)}
            >
              Delivery Address
            </button>

            <button
              className={` px-5 py-1 rounded-lg text-white
          ${activeTab === "orders" ? "bg-primary" : "bg-lightText"}
          `}
              onClick={() => navigate(`/customer/view/${id}?activeTab=orders`)}
            >
              Orders
            </button>

            <button
              className={` px-5 py-1 rounded-lg text-white
          ${activeTab === "payment" ? "bg-primary" : "bg-lightText"}
          `}
              onClick={() => navigate(`/customer/view/${id}?activeTab=payment`)}
            >
              payment
            </button>

            <button
              className={` px-5 py-1 rounded-lg text-white
          ${activeTab === "comments" ? "bg-primary" : "bg-lightText"}
          `}
              onClick={() =>
                navigate(`/customer/view/${id}?activeTab=comments`)
              }
            >
              Comments
            </button>
            <button
              className={` px-5 py-1 rounded-lg text-white
          ${activeTab === "filecomments" ? "bg-primary" : "bg-lightText"}
          `}
              onClick={() =>
                navigate(`/customer/view/${id}?activeTab=filecomments`)
              }
            >
              File Comments
            </button>
          </div>
        </div>

        {activeTab === "customer" && <ViewCustomerComponent />}
        {activeTab === "activity" &&
          (permission?.read || permission?.write) && (
            <CustomerActivityList activeTab={activeTab} />
          )}
        {activeTab === "address" && (
          <CustomerDeliveryListList activeTab={activeTab} />
        )}
        {activeTab === "orders" && <CustomerOrdersList activeTab={activeTab} />}
        {activeTab === "payment" && (
          <CustomerPaymentList activeTab={activeTab} />
        )}
        {activeTab === "comments" && <CustomerCommentsList />}
        {activeTab === "filecomments" && <CustomerFileCommentsLits />}
      </section>
    </MainLayout>
  );
};

export default ViewCustomer;
